import { useQuery } from "@tanstack/react-query";
import { getReleaseDependencies } from "../api/real-cookie-banner.js";
import { useStores } from "../store/root.js";
import { QueryKeys } from "../util/query-keys.js";
function useReleaseDependenciesGet(customRef, params) {
    const { rcbAuthenticationStore } = useStores();
    const releaseQuery = useQuery(QueryKeys.getReleaseDependencies(customRef), ({ signal })=>{
        return getReleaseDependencies({
            signal,
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: params
        });
    }, {
        enabled: !!customRef,
        retry: false
    });
    return releaseQuery;
}
export { useReleaseDependenciesGet };
